import Modal from "common/components/Modal/Modal"
import DocumentoEditado from "features/Crear/forms/DocumentoEditado"
import FechaVencimiento from "features/Crear/forms/FechaVencimiento"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import DatosCliente from "../../forms/DatosCliente"
import DatosFactura from "../../forms/DatosFactura"
import Descuento from "../../forms/Descuento"
import DiasPago from "../../forms/DiasPago"
import DocumentoCreado from "../../forms/DocumentoCreado"
import FechaEmision from "../../forms/FechaEmision"
import FechaOperacion from "../../forms/FechaOperacion"
import FormaPago from "../../forms/FormaPago"
import Logo from "../../forms/Logo"
import Observaciones from "../../forms/Observaciones"
import Retencion from "../../forms/Retencion"
import Titulo from "../../forms/Titulo"
import {
  setShowConceptosModal,
  setShowDatosLibradoModal,
  setShowDescuentoModal,
  setShowDiasPagoModal,
  setShowDocumentoCreadoModal,
  setShowDocumentoEditadoModal,
  setShowFechaEmisionModal,
  setShowFechaOperacionModal,
  setShowFechaVencimientoModal,
  setShowFormaPagoModal,
  setShowLogoModal,
  setShowObservacionesModal,
  setShowRetencionModal,
  setShowTituloModal,
} from "../../redux/slices/newDocumentoSettingsSlice"

// TODO: SOLO SIRVE EN FACTURAS REC - DELETE CUANDO SE MIGRE

const RenderModals = ({
  onChangeLastAvailableNumero,
  redirectOnCreate,
  isLibrado,
  sinValorar,
  isEditFormaPago,
  setIsEditFormaPago,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const {
    showConceptosModal,
    showDatosLibradoModal,
    showFechaOperacionModal,
    showDescuentoModal,
    showFormaPagoModal,
    showDiasPagoModal,
    showLogoModal,
    showRetencionModal,
    showFechaEmisionModal,
    showFechaVencimientoModal,
    showTituloModal,
    showDocumentoCreadoModal,
    showDocumentoEditadoModal,
    showObservacionesModal,
  } = useSelector(newDocumentoSettingsSelector)
  const { librado, librador } = useSelector((state) => state.newDocumento)
  const dispatch = useDispatch()

  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes } = useTaxes()
  const taxesFormatted = taxes.map((impuesto) => ({
    // @ts-expect-error TS(2698): Spread types may only be created from object types...
    ...impuesto,
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
    label: `${impuesto.nombre}`,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    value: impuesto.id,
    // @ts-expect-error TS(2339): Property 'valor' does not exist on type 'never'.
    fieldValue: impuesto.valor,
  }))

  return (
    <>
      <Modal
        header={t("crear.facturaRec.modal.conceptTitle")}
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowConceptosModal(false))}
        visible={showConceptosModal}
        position='right'
        maskClassName='!tw-z-30'
      >
        <DatosFactura
          // @ts-expect-error TS(2322): Type '{ sinValorar: $TSFixMe; taxes: $TSFixMe[]; librado: an...
          sinValorar={sinValorar}
          taxes={taxesFormatted}
          librado={librado}
          librador={librador}
          isLibrado={isLibrado}
          // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
          onHide={() => dispatch(setShowConceptosModal(false))}
          t={t}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.clientTitle")}
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowDatosLibradoModal(false))}
        visible={showDatosLibradoModal}
        position='right'
      >
        <DatosCliente
          // @ts-expect-error TS(2322): Type '{ onHide: () => any; t: TFunction<"translati...
          onHide={() => dispatch(setShowDatosLibradoModal(false))}
          t={t}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowFechaOperacionModal(false))}
        visible={showFechaOperacionModal}
      >
        <FechaOperacion
          // @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to...
          onHide={() => dispatch(setShowFechaOperacionModal(false))}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowObservacionesModal(false))}
        visible={showObservacionesModal}
      >
        <Observaciones
          // @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to...
          onHide={() => dispatch(setShowObservacionesModal(false))}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowFormaPagoModal(false))}
        visible={showFormaPagoModal}
      >
        <FormaPago
          // @ts-expect-error TS(2322): Type '{ onHide: () => any; isEditFormaPago: $TSFixMe; s...
          onHide={() => dispatch(setShowFormaPagoModal(false))}
          isEditFormaPago={isEditFormaPago}
          setIsEditFormaPago={setIsEditFormaPago}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowFechaEmisionModal(false))}
        visible={showFechaEmisionModal}
      >
        <FechaEmision
          // @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to...
          onHide={() => dispatch(setShowFechaEmisionModal(false))}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowFechaVencimientoModal(false))}
        visible={showFechaVencimientoModal}
      >
        <FechaVencimiento
          // @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to...
          onHide={() => dispatch(setShowFechaVencimientoModal(false))}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowTituloModal(false))}
        visible={showTituloModal}
      >
        <Titulo
          // @ts-expect-error TS(2322): Type '{ onChangeLastAvailableNumero: $TSFixMe; onHide: ...
          onChangeLastAvailableNumero={onChangeLastAvailableNumero}
          // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
          onHide={() => dispatch(setShowTituloModal(false))}
        />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowDiasPagoModal(false))}
        visible={showDiasPagoModal}
      >
        {/* @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to... */}
        <DiasPago onHide={() => dispatch(setShowDiasPagoModal(false))} />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowDescuentoModal(false))}
        visible={showDescuentoModal}
      >
        {/* @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to... */}
        <Descuento onHide={() => dispatch(setShowDescuentoModal(false))} />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowLogoModal(false))}
        visible={showLogoModal}
      >
        {/* @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to... */}
        <Logo onHide={() => dispatch(setShowLogoModal(false))} />
      </Modal>

      <Modal
        header={t("crear.facturaRec.modal.newField")}
        size='small'
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowRetencionModal(false))}
        visible={showRetencionModal}
        maskClassName='!tw-z-30'
      >
        <Retencion
          // @ts-expect-error TS(2322): Type '{ isLibrado: $TSFixMe; onHide: () => any; }' is n...
          isLibrado={isLibrado}
          // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
          onHide={() => dispatch(setShowRetencionModal(false))}
        />
      </Modal>

      <Modal
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowDocumentoCreadoModal(false))}
        visible={showDocumentoCreadoModal}
        backdrop={false}
        size='small'
        closable={false}
      >
        <DocumentoCreado
          redirectOnCreate={redirectOnCreate}
          isLibrado={isLibrado}
          // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
          onHide={() => dispatch(setShowDocumentoCreadoModal(false))}
        />
      </Modal>
      <Modal
        // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to parameter of type 'never'.
        onHide={() => dispatch(setShowDocumentoEditadoModal(false))}
        visible={showDocumentoEditadoModal}
        backdrop={false}
        size='small'
        closable={false}
      >
        <DocumentoEditado
          // @ts-expect-error TS(2322): Type '{ onHide: () => any; }' is not assignable to...
          onHide={() => dispatch(setShowDocumentoEditadoModal(false))}
        />
      </Modal>
    </>
  )
}

export default RenderModals
